'use client';

import React from 'react';

interface AwsRumClientProps {
  readonly id: string;
  readonly identityPoolId: string;
  readonly nonce?: string;
}

export function AwsRumClient({ id, identityPoolId, nonce }: AwsRumClientProps): JSX.Element {
  return (
    <script
      nonce={nonce}
      dangerouslySetInnerHTML={{
        __html: `(function(n,i,v,r,s,c,x,z){x=window.AwsRumClient={q:[],n:n,i:i,v:v,r:r,c:c};window[n]=function(c,p){x.q.push({c:c,p:p});};z=document.createElement('script');z.async=true;z.src=s;document.head.insertBefore(z,document.head.getElementsByTagName('script')[0]);})(
                'cwr',
                '${id}',
                '1.0.0',
                'eu-west-1',
                'https://client.rum.us-east-1.amazonaws.com/1.16.1/cwr.js',
                {
                  sessionSampleRate: 0.5,
                  identityPoolId: '${identityPoolId}',
                  endpoint: "https://dataplane.rum.eu-west-1.amazonaws.com",
                  telemetries: ["performance","errors","http"],
                  allowCookies: true,
                  enableXRay: true
                }
              );`,
      }}
    />
  );
}
